import type { AnimationType } from '../../../../items/animation/animation-item-type';

// 애니메이션 드래그 데이터 타입
export const ANIMATION_DRAG_TYPE = 'application/x-editor-animation';

// AnimationType re-export
export type { AnimationType };

export interface AnimationDragData {
  type: AnimationType;
  name: string;
}

// 드래그 중인 애니메이션 데이터를 전역으로 저장 (dragover에서 getData 불가능하기 때문)
let currentAnimationDragData: AnimationDragData | null = null;

export const getCurrentAnimationDragData = (): AnimationDragData | null =>
  currentAnimationDragData;

export const setCurrentAnimationDragData = (
  data: AnimationDragData | null,
): void => {
  currentAnimationDragData = data;
};
